"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LightningBoltIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

var _excluded = ["title"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** LightningBolt */


var LightningBoltIcon = function LightningBoltIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Speed and efficiency" : _ref$title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 125 161"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: (0, _helpers.color)(props.fill),
    fillRule: "evenodd",
    d: "M57.278 9.978a4 4 0 013.254 3.93v51.82h39.449a4 4 0 013.706 5.503l-32.503 80.18a4 4 0 01-7.707-1.503v-51.82H24.981a4 4 0 01-3.723-5.464l31.552-80.18a4 4 0 014.468-2.466zm-26.425 80.11h36.624a4 4 0 014 4v35.306l22.566-55.666h-37.51a4 4 0 01-4-4V34.997l-21.68 55.091z",
    clipRule: "evenodd"
  }));
};

exports.LightningBoltIcon = LightningBoltIcon;
LightningBoltIcon.displayName = "LightningBoltIcon";